import styled from "styled-components";
import { FloatButton, Layout, Menu as AntMenu } from "antd";
import { MenuOutlined } from "@ant-design/icons";

const { Sider: AntSider } = Layout;

// Mobile menu button (appears when sidebar is hidden)
export const MobileMenuIcon = styled(FloatButton).attrs({
  icon: <MenuOutlined />,
  shape: "square",
})`
  display: none;
  width: 48px;
  left: 16px;
  bottom: 16px;
  z-index: 999;

  .ant-float-btn-body {
    background: ${(props) => props.theme.primaryColor};
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    background: ${(props) => props.theme.primaryColor};
    width: 48px;
  }

  svg {
    color: #fff;
    font-size: 20px;
  }

  //   @media screen and (max-width: 575px) {
  //     display: block;
  //   }
`;

// Sidebar with responsive behavior
export const Sider = styled(AntSider)`
  background: transparent !important;
  padding-bottom: 0 !important;
  margin-bottom: -18px;
  // Style menu items
  .ant-menu-item,
  .ant-menu-submenu-title {
    margin: 0 0 8px 0 !important;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    background: #fff;
  }

  // Hide text when collapsed
  .ant-menu-item .ant-menu-title-content,
  .ant-menu-submenu .ant-menu-title-content {
    display: ${(props) => (props.collapsed ? "none" : "inline")} !important;
  }

  // Center icons when collapsed
  .ant-menu-inline-collapsed {
    .ant-menu-item,
    .ant-menu-submenu-title {
      padding-left: 12px !important;
      justify-content: center;
    }
  }

  // Group title
  .ant-menu-item-group-title {
    padding-top: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #1e1e1e;
    padding-left: 0;
  }

  // Submenu styles
  .ant-menu-submenu-title {
    svg path,
    svg circle,
    svg rect {
      stroke: ${(props) => props.theme.primaryColor} !important;
    }
  }

  .ant-menu-submenu-selected .ant-menu-submenu-title {
    background: ${(props) => props.theme.primaryColor} !important;
    color: #fff !important;

    svg path,
    svg circle,
    svg rect {
      stroke: #fff !important;
    }
  }

  // Dropdown submenu
  .ant-menu-sub {
    background: white !important;
    border-radius: 8px !important;
    margin-right: 8px;
    .ant-menu-item {
      padding-left: 24px !important;
      background: white !important;
      color: #000 !important;
      font-weight: 400 !important;

      svg path,
      svg circle,
      svg rect {
        stroke: #868686 !important;
      }
    }

    .ant-menu-item-selected {
      color: ${(props) => props.theme.primaryColor} !important;

      svg path,
      svg circle,
      svg rect {
        stroke: ${(props) => props.theme.primaryColor} !important;
      }
    }
  }

  // Expanded state (desktop/tablet)
  &:not(.ant-layout-sider-collapsed) {
    width: 280px !important;
    min-width: 280px !important;
    max-width: 280px !important;
    margin-bottom: -18px !important;
    padding-bottom: 0 !important;
    position: relative;

    .ant-layout-sider-trigger {
      width: 280px !important;

      @media screen and (max-width: 575px) {
        display: none !important;
      }
    }

    @media screen and (max-width: 1024px) {
      position: fixed;
      z-index: 10;
    }
  }

  // Mobile-specific: hide sidebar unless forced open
  @media screen and (max-width: 575px) {
    position: fixed !important;
    top: 0;
    left: 0;
     height: 100vh !important;
  min-height: 100vh !important;

  z-index: 998;
    transform: ${(props) =>
      props.forcedcollapsed ? "translateX(-100%)" : "translateX(0)"};
    transition: transform 0.3s ease;
    width: 280px !important;
    min-width: 280px !important;
    max-width: 280px !important;

    .ant-layout-sider-trigger {
      display: none !important;
    }
  }

  // Always hide trigger on mobile
  .ant-layout-sider-trigger {
    background: ${(props) => props.theme.primaryColor};
    height: 48px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;

    &:hover {
      background: ${(props) => props.theme.primaryColor};
    }

    svg {
      color: #fff;
    }

    @media screen and (max-width: 575px) {
      display: none !important;
    }
  }
`;

// Ant Design Menu override
export const Menu = styled(AntMenu)`
  background: ${(props) => props.theme.backgroundColor} !important;
  height: 100%;
  border-right: 0 !important;
  color: #f00;
  font-weight: 500;
  .ant-menu-item,
  .ant-menu-submenu {
    overflow: hidden;
    white-space: nowrap;
  }
`;

// Scrollable wrapper
export const MenuWrapper = styled.div.attrs({
  className: "custom-scroll",
})`
  position: sticky;
  top: 80px;
  bottom: 0;
  padding: 24px 8px 24px 16px; /* Reduced padding for compact icon mode */
  height: calc(100vh - 124px);

  @media screen and (max-width: 575px) {
    height: calc(100vh - 80px);
  }

  overflow-y: auto;
  background: ${(props) => props.theme.backgroundColor} !important;
  scrollbar-width: thin;
  box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.04);

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  > ul > :last-child {
    padding-bottom: 48px;
  }
`;

export const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  // background: rgba(0, 0, 0, 0.35);
  z-index: 0;
`;
